import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "ticketino-api-client";
import { OrganizerWithUsernameAlreadyExists } from "../utils/api";
import { useLanguage } from "../hooks/useLanguage";
import { useOrder } from "../hooks/useOrder";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Loading from "./components/Loading";

const Username = () => {
    const [regularToken, setRegularToken] = useState(null);
    const [username, setUsername] = useState('');
    const [error, setError] = useState('');

    const [resources, setResources] = useState({});
    const { language } = useLanguage();

    const navigate = useNavigate();
    let baseUrl = process.env.REACT_APP_BASEURL_API;
    api.defaults.baseURL = baseUrl;

    const order = useOrder(baseUrl);

    useEffect(() => {
        setRegularToken(localStorage.getItem("token"));
        requestFormSettings();
    }, []);

    useEffect(() => {
        requestResources();
    }, [language]); //everytime language is changed

    const requestFormSettings = async () => {
        await axios.get(`form/formsettings`).then((res) => {
            //setPosId(res.data.posId);
        });
    };

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };


    const requestConfirmationCode = async (username) => {
       return await axios
            //.post(`https://localhost:44317/Account/RegisterExternal?username=${username}`)
            .post(`https://accounts.ticketino.com/Account/RegisterExternal?username=${username}`)
            .catch((error) => console.error(error.response.data));
    };

    // Simple email validation regex
    const isValidEmail = (email) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    const handleCheckUsername = async (e) => {
        e.preventDefault();

        if (!isValidEmail(username)) {
            setError("Please enter a valid email address.");
            return;
        }

        setError(""); // Clear error if valid

        try {
            const usernameAlreadyExists = await fetchOrganizerWithUsernameAlreadyExists(username)

            localStorage.setItem("existingUsername", username); // Save existingUsername in session

            if (usernameAlreadyExists) {
                navigate(`/${language}/login`);
            } else {
                const res = await requestConfirmationCode(username); // Fetch resources for confirmation code page
                const loginUserId = res.data;

                // store logginUserId for next step 
                localStorage.setItem("loginUserId", loginUserId);

                navigate(`/${language}/confirmation-code`);
            }
        } catch (err) {
            console.error('username check failed:', err.response?.data || err.message);
        }
    };

    const fetchOrganizerWithUsernameAlreadyExists = async (username) => {
        try {
            if (!regularToken) {
                throw new Error("No buyerToken token found at fetchOrganizerWithUsernameAlreadyExists");
            }
            const data = await OrganizerWithUsernameAlreadyExists(baseUrl, "token", regularToken, username);

            return data;
        } catch (error) {
            console.error('Error fetching organizer with username already exists:', error);
        }
    };

    return (
        <>
            <Header language={language} pagePath="login" pageTitle={resources?.UsernameLoginOrRegister}
                ticketCount={order?.tickets?.length || 0} isLoginVisible={false} isSoppingcartVisible={false} />

            <div className="page-container">

                <div className="container wrapper">

                    {/* inputs */}
                    <form onSubmit={handleCheckUsername}>
                        <div className="form-group row">
                            <label htmlFor="staticEmail" className="col-sm-12 col-form-label">{resources?.Account_LoginEmailUserName}</label>
                            <div className="col-sm-12">
                                <input
                                    className="form-control"
                                    name="username"
                                    value={username}
                                    onChange={(e) => {
                                        setUsername(e.target.value);
                                        if (error && isValidEmail(e.target.value)) setError('');
                                    }}
                                />
                                {error && (
                                    <div className="text-danger mt-2 fw-bold">{error}</div>
                                )}
                                <div className="mt-2">{resources?.Account_LoginDescription}</div>
                            </div>
                        </div>

                        {/* infos */}
                        {/*<div className="row mt-4">*/}
                        {/*    <div className="col-md-12 d-flex flex-column">*/}
                        {/*        <span><b>{resources?.Account_LoginNotYetRegistered}</b></span>*/}
                        {/*        <span>{resources?.Account_LoginNotYetRegisteredDesc}</span>*/}
                        {/*    </div>*/}
                        {/*</div>*/}

                        {/* button */}
                        <div className="row mt-5">
                            <div className="col-md-12 text-center">
                                <button className="btn-custom btn-navigation" type="submit">{resources?.UsernameLogin}</button>
                            </div>
                        </div>

                    </form>
                </div>
                
            </div>

            <Footer language={language} />
        </>
    )
}

export default Username